
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/founders-thoughts",
      function () {
        return require("private-next-pages/founders-thoughts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/founders-thoughts"])
      });
    }
  